<div class="metin-notu-dialog">
  <!-- Toolbar - Point Selection -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="baslangicNokta" (click)="baslangicNoktasiSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(0, 255, 0, 0.15), rgba(0, 255, 0, 0.25)); border-color: rgba(0, 255, 0, 0.4); color: #00FF00;">
          <i class="icon map marker alternate"></i>
          {{baslangicNokta ? 'Başlangıç ✓' : 'Başlangıç Noktası Seç'}}
        </button>
        <button class="catia-btn" [class.active]="bitisNokta" (click)="bitisNoktasiSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(255, 215, 0, 0.15), rgba(255, 215, 0, 0.25)); border-color: rgba(255, 215, 0, 0.4); color: #FFD700;">
          <i class="icon map marker alternate"></i>
          {{bitisNokta ? 'Bitiş ✓' : 'Bitiş Noktası Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Ok Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="okAyarlariAcik = !okAyarlariAcik">
        <i class="icon long arrow alternate right"></i>
        <span>Ok Ayarları</span>
        <div class="chevron" [class.right]="!okAyarlariAcik" [class.down]="okAyarlariAcik"></div>
      </div>

      @if (okAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Metin -->
        <div class="ayar-satir">
          <label>Metin:</label>
          <input type="text" [(ngModel)]="metin" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="Açıklama girin..." />
        </div>

        <!-- Çizgi Tipi -->
        <div class="ayar-satir">
          <label>Çizgi Tipi:</label>
          <select [(ngModel)]="tip" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            <option value="solid">Düz</option>
            <option value="dashed">Kesikli</option>
          </select>
        </div>

        <!-- Ok Tipi -->
        <div class="ayar-satir">
          <label>Ok Tipi:</label>
          <select [(ngModel)]="okTipi" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            <option value="filled">Dolu</option>
            <option value="open">Açık</option>
            <option value="none">Yok</option>
          </select>
        </div>

        <!-- Çizgi Kalınlığı -->
        <div class="ayar-satir">
          <label>Çizgi Kalınlığı:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="cizgiKalinligi" (ngModelChange)="onizlemeGuncelle()"
                   min="1" max="5" step="0.5" />
            <span class="deger-gosterge">{{cizgiKalinligi.toFixed(1)}}</span>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Görünüm Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Görünüm Ayarları</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Renk -->
        <div class="ayar-satir">
          <label>Renk:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r) {
              <div class="renk-kutu" [style.background-color]="r"
                   [class.secili]="renk === r"
                   (click)="renk = r; onizlemeGuncelle()"></div>
              }
            </div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="onizlemeGuncelle()" class="renk-input" />
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Yazı Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyut" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="24" step="1" />
            <span class="deger-gosterge">{{boyut}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutOk" class="catia-checkbox">
            <label for="sabitBoyutOk" class="checkbox-label">Aktif</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()" [disabled]="!baslangicNokta || !bitisNokta">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>
</div>
